/**
 * Spotify: vad spelas just nu.
 *
 * progress_ms och duration_ms är hela poängen för sensormärkningen — de
 * säger var i låten vi är, exaktare än AudD:s timecode (millisekunder mot
 * hela sekunder). item.id blir låtens id i vår katalog, samma format som
 * AudD-vägen redan använder för Spotify-träffar.
 */
export async function getCurrentlyPlaying(accessToken) {
  const res = await fetch("https://api.spotify.com/v1/me/player/currently-playing", {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  // 204 = inget spelas alls just nu.
  if (res.status === 204) return { playing: false };

  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`Currently playing failed: ${res.status} ${txt}`);
  }

  const data = await res.json();
  const item = data?.item;
  if (!item) return { playing: false };

  return {
    playing: true,
    // Tidpunkten läses av lokalt, inte ur Spotifys timestamp-fält: det är
    // känt för att ibland ligga efter, och positionen måste stämma mot vår
    // egen klocka för att klippets starttid ska gå att slå upp.
    capturedAt: Date.now(),
    trackId: item.id,
    title: item.name,
    artist: item.artists?.map((a) => a.name).join(", ") ?? "",
    album: item.album?.name ?? null,
    albumCover: item.album?.images?.[0]?.url ?? null,
    progressMs: data?.progress_ms ?? 0,
    durationMs: item.duration_ms ?? null,
    isPlaying: data?.is_playing ?? false,
  };
}
